module.exports = __webpack_public_path__ + "static-v-shop/1786392158156/img/landing-mobile-fondo-2.cda3e9f3.png";